<p-toast></p-toast>
<div class="grid">
    <div class="col-12">
        <div class="mb-5">
            <p-breadcrumb [model]="breadcrumbItems" [home]="home"></p-breadcrumb>
        </div>
    </div>

    <div class="col-12">
        <div class="card shadow-2">
            <p-button label="Añadir Especialista" (click)="add()" icon="pi pi-plus" onKeyPress="" />
        </div>
        <div class="card shadow-2">
            <specialists-table [data]="specialists$ | async" [global]="true" />
        </div>
    </div>
</div>

<p-dialog
    (onHide)="resetForm()"
    header="Crear Especialista"
    [(visible)]="viewModal"
    [modal]="true"
    [breakpoints]="{ '1199px': '85vw', '575px': '90vw' }"
    [style]="{ width: '40vw' }"
    [draggable]="false"
    [resizable]="false"
    [contentStyle]="{ overflow: 'visible' }"
>
    <ng-template pTemplate="content" #modalNested>
        <form class="p-fluid py-2" [formGroup]="form">
            <div class="field">
                <p-fileUpload
                    accept="image/png, image/jpeg"
                    chooseLabel="Seleccionar imagen"
                    chooseIcon="pi pi-upload"
                    [customUpload]="true"
                    [maxFileSize]="5000000"
                    (uploadHandler)="onUpload($event)"
                    [auto]="true"
                >
                    <ng-template pTemplate="file">
                        @if (selectedFile && previewUrl) {
                            <p-image
                                [src]="previewUrl"
                                alt="Image"
                                width="150"
                                styleClass="flex justify-content-center"
                            />

                        }
                    </ng-template>
                </p-fileUpload>
                @if (this.form.controls.fileImage.touched && this.form.controls.fileImage.dirty &&
                this.form.controls.fileImage.invalid) {
                    <small class="p-error">Imagen inválida</small>
                }
            </div>
            <div class="field">
        <span class="p-float-label">
          <input [class]="
              this.form.controls.name.invalid &&
              (this.form.controls.name.dirty || this.form.controls.name.touched)
                ? 'ng-invalid ng-dirty'
                : ''
            " id="name" type="text" pInputText formControlName="name" />
          <label for="name">Nombre</label>
        </span>
                @if (this.form.controls.name.invalid && (this.form.controls.name.dirty ||
                    this.form.controls.name.touched)) {
                    <small class="p-error">Campo requerido</small>
                }
            </div>
            <div class="field">
        <span class="p-float-label">
          <input [class]="
              this.form.controls.email.invalid &&
              (this.form.controls.email.dirty || this.form.controls.email.touched)
                ? 'ng-invalid ng-dirty'
                : ''
            " id="email" type="text" pInputText formControlName="email" />
          <label for="email">Email</label>
        </span>
                @if (this.form.controls.email.invalid && (this.form.controls.email.dirty ||
                    this.form.controls.email.touched)) {
                    <small class="p-error">Ingresa un email válido</small>
                }
            </div>
            <div class="field">
        <span class="p-float-label">
          <textarea
              id="curriculum"
              [class]="
              this.form.controls.curriculum.invalid &&
              (this.form.controls.curriculum.dirty || this.form.controls.curriculum.touched)
                ? 'ng-invalid ng-dirty'
                : ''
            "
              rows="3"
              cols="30"
              formControlName="curriculum"
              pInputTextarea
          ></textarea>
          <label for="inputtext">Currículum</label>
        </span>
                @if (this.form.controls.curriculum.invalid && (this.form.controls.curriculum.dirty ||
                    this.form.controls.curriculum.touched)) {
                    <small class="p-error">Campo requerido</small>
                }
            </div>
            <div class="field">
                <span class="block mb-1">Teléfono</span>
                <ngx-intl-tel-input
                    [cssClass]="'p-inputtext p-component p-element min-w-full'"
                    [onlyCountries]="onlyCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="false"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.Spain"
                    [maxLength]="15"
                    [phoneValidation]="true"
                    [separateDialCode]="true"
                    [numberFormat]="PhoneNumberFormat.National"
                    name="phoneNumber"
                    formControlName="phoneNumber"
                    id="phoneNumber"
                >
                </ngx-intl-tel-input>

                @if (this.form.controls.phoneNumber.touched && this.form.controls.phoneNumber.dirty &&
                this.form.controls.phoneNumber.invalid) {
                    <small class="p-error block">Ingresa un número de teléfono válido</small>
                }
            </div>
            <div class="field">
        <span class="p-float-label">
          <input [class]="
              this.form.controls.curriculum.invalid &&
              (this.form.controls.curriculum.dirty || this.form.controls.curriculum.touched)
                ? 'ng-invalid ng-dirty'
                : ''
            " id="specialty" type="text" pInputText formControlName="specialty" />
          <label for="inputtext">Especialidad</label>
        </span>
                @if (this.form.controls.specialty.invalid && (this.form.controls.specialty.dirty ||
                    this.form.controls.specialty.touched)) {
                    <small class="p-error">Campo requerido</small>
                }
            </div>
            <div class="field">
        <span class="p-float-label">
          <p-dropdown
              [class]="
              this.form.controls.dateDuration.invalid &&
              (this.form.controls.dateDuration.dirty || this.form.controls.dateDuration.touched)
                ? 'ng-invalid ng-dirty'
                : ''
            "
              [style]="{ 'min-width': '166px' }"
              inputId="dateDuration"
              formControlName="dateDuration"
              [options]="dateMinutes"
              optionLabel="name"
          />
          <label for="selectedDay">Duración de cita</label>
        </span>
                @if (this.form.controls.dateDuration.invalid && (this.form.controls.dateDuration.dirty ||
                    this.form.controls.dateDuration.touched)) {
                    <small class="p-error">Campo requerido</small>
                }
            </div>
            @if (appName !== "Caser MIMAvet") {
                <div class="field">
        <span class="p-float-label">
          <input [class]="
              this.form.controls.datePrice.invalid &&
              (this.form.controls.datePrice.dirty || this.form.controls.datePrice.touched)
                ? 'ng-invalid ng-dirty'
                : ''
            " id="datePrice" type="number" pInputText formControlName="datePrice" />
          <label for="datePrice">Precio de cita</label>
        </span>
                    @if (this.form.controls.datePrice.invalid && (this.form.controls.datePrice.dirty ||
                        this.form.controls.datePrice.touched)) {
                        <small class="p-error">Campo requerido</small>
                    }
                </div>

            }

            <div class="max-w-max mb-2">
                <button
                    pButton
                    pRipple
                    type="button"
                    label="Añadir horario"
                    icon="pi pi-plus"
                    class="p-button-text"
                    (click)="addSchedule()"
                ></button>
            </div>

            <div class="field">
                <div class="surface-section">
                    <ul class="list-none p-0 m-0">
                        <li
                            *ngFor="let day of getDiaryDays(diary)"
                            class="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap"
                        >
                            <div class="text-500 w-6 md:w-2 font-medium mb-2">{{ getDayName(day) }}</div>
                            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                                <p-chip
                                    *ngFor="let time of diary[day]"
                                    (onRemove)="onRemoveSchedule(day, time)"
                                    [removable]="true"
                                    [label]="time.start + ' a ' + time.end"
                                    class="mr-2 mb-2 inline-block"
                                ></p-chip>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </form>
        <p-dialog
            (onHide)="resetFormNested()"
            [contentStyle]="{ overflow: 'visible' }"
            header="Añadir horario"
            [(visible)]="viewModalNested"
            appendTo="modalNested"
            [modal]="true"
            [breakpoints]="{ '1400px': '75vw', '1199px': '75vw', '575px': '90vw' }"

            [draggable]="false"
            [resizable]="false"
        >
            <ng-template pTemplate="content">
                <form [formGroup]="formNested">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-4">
                            <div class="field">
                <span class="p-float-label">
                  <p-dropdown
                      [class]="
                      this.formNested.controls.day.invalid &&
                      (this.formNested.controls.day.dirty || this.formNested.controls.day.touched)
                        ? 'ng-invalid ng-dirty'
                        : ''
                    "
                      [style]="{ 'min-width': '166px' }"
                      inputId="selectedDay"
                      formControlName="day"
                      [options]="days"
                      optionLabel="name"
                  />
                  <label for="selectedDay">Selecciona el día</label>
                </span>
                                @if (this.formNested.controls.day.invalid && (this.formNested.controls.day.dirty ||
                                    this.formNested.controls.day.touched)) {
                                    <small class="p-error">Campo requerido</small>
                                }
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <div class="field">
                <span class="p-float-label">
                  <p-calendar
                      [stepMinute]="15"
                      (onShow)="setInitialTimeStartAt()"
                      [class]="
                      this.formNested.controls.startAt.invalid &&
                      (this.formNested.controls.startAt.dirty ||
                        this.formNested.controls.startAt.touched)
                        ? 'ng-invalid ng-dirty'
                        : ''
                    "
                      inputId="startAt"
                      [style]="{ 'max-width': '166px' }"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      formControlName="startAt"
                      [timeOnly]="true"
                      [readonlyInput]="true"
                  >
                    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                      <i
                          class="pi pi-clock pointer-events-none"
                          (click)="clickCallBack($event)"
                          onKeyPress=""
                      ></i> </ng-template
                    ></p-calendar>
                  <label for="startAt">Inicio</label>
                </span>
                                @if (this.formNested.controls.startAt.invalid &&
                                (this.formNested.controls.startAt.dirty || this.formNested.controls.startAt.touched)) {
                                    <small class="p-error">Campo requerido</small>
                                }
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <div class="field">
                <span class="p-float-label">
                  <p-calendar
                      (onShow)="setInitialTimeEndAt()"
                      [stepMinute]="15"
                      [readonlyInput]="true"
                      [class]="
                      this.formNested.controls.endAt.invalid &&
                      (this.formNested.controls.endAt.dirty ||
                        this.formNested.controls.endAt.touched)
                        ? 'ng-invalid ng-dirty'
                        : ''
                    "
                      inputId="endAt"
                      [style]="{ 'max-width': '166px' }"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      formControlName="endAt"
                      [timeOnly]="true"
                  >
                    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                      <i
                          class="pi pi-clock pointer-events-none"
                          (click)="clickCallBack($event)"
                          onKeyPress=""
                      ></i> </ng-template
                    ></p-calendar>
                  <label for="endAt">Fin</label>
                </span>
                                @if (this.formNested.controls.endAt.invalid && (this.formNested.controls.endAt.dirty
                                    || this.formNested.controls.endAt.touched)) {
                                    <small class="p-error">Campo requerido</small>
                                }
                                @if (formNested.hasError('endAtBeforeStartAt')) {
                                    <small class="p-error"> Fecha fin, debe ser mayor a fecha inicio </small>
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </ng-template>
            <ng-template pTemplate="footer">
                <p-button (click)="onAddSchedule()" icon="pi pi-plus" label="Añadir" onKeyPress="" />
            </ng-template>
        </p-dialog>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button
            [loading]="loading"
            icon="pi pi-check"
            label="Guardar"
            onKeyPress=""
            (click)="onSubmit()"
        />
    </ng-template>
</p-dialog>
